import { createSlice } from "@reduxjs/toolkit"
import { ProductType, featureSectionType, recommendedSectionType } from "./Types"

type initialstateType = {
    collection: {
        productId : string,
        productDetail: ProductType,
        featureSection?: featureSectionType,
        recommendedSection?: recommendedSectionType 
    },
    status: {
        productDetailAndAddToCartLoading: boolean,
        loading: boolean,
        error: boolean,
        errorMessage: string,
        errorType: string,
    }
}

var initialstate: initialstateType = {
    collection: {
        productId : "",
        productDetail: {
            sellingPlanGroups: {
                edges: []
            },
            metafields: {
                nodes: []
            }
        },
        featureSection:[],
        recommendedSection:[]
    },
    status: {
        productDetailAndAddToCartLoading: false,
        error: false,
        errorMessage: "",
        errorType: "",
        loading: false
    }
}

const productDetail = createSlice({
    name: "pdp",
    initialState: initialstate,
    reducers: {
        set_productDetail_featureSection_recommendedSection: (state, action) => {
            state.collection = {
                productId : action?.payload?.productId,
                productDetail: { ...action?.payload?.productDetail },
                featureSection: [ ...action?.payload?.featureSection ],
                recommendedSection: [...action?.payload?.recommendedSection],
            }
        },
        setLoadingStatus: (state, action) => {
            state.status.loading = action.payload
        },
        setProductDetailAndAddToCartLoading: (state, action) => {
            state.status.productDetailAndAddToCartLoading = action.payload
        }
    }
})

export const productDetailScileReducer = productDetail.reducer;
export const productDetailSliceAction = productDetail.actions;
